/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Transforme une date du format dd/mm/yyyy vers yyyy-mm-dd attendu par l'API
 */
const stringToAPIDateFormat = (value: string): string => {
  const [day, month, year] = value.split("/");
  const dateFromParam = new Date(+year, +month - 1, +day);
  return dateFromParam.toLocaleDateString("en-CA");
};

export default stringToAPIDateFormat;
